import { useCallback } from "react";
import { useNavigate } from "react-router";
import { MaxSearchResultCount, universalSearchResultItem, useUniversalSearch } from "Shared/UniversalSearch";
import { IcmDirectoryContactResponse, useORPCClient } from "Core/oRPC";
import { getContactLink } from "Apps/Service/ServiceRoutes";
import { AppRegistry } from "Apps/AppRegistry";
import { getContactDisplayName } from "./ContactsApp.utils";

export const useSearchContact = () => {
    const navigate = useNavigate();
    const { oncallApi } = useORPCClient();

    const searchContact = useCallback(
        async (word: string) => {
            if (!word) {
                return [];
            }

            const contacts = await oncallApi.getContactv2GetPartialContacts({
                searchQuery: word
            });

            const resultList: universalSearchResultItem[] = contacts
                .filter((contact) => contact.Alias)
                .map((contact: IcmDirectoryContactResponse) => {
                    const displayName = getContactDisplayName(contact);
                    const alias = contact.Alias ?? "";
                    const title = displayName.trim() || alias;
                    const navigationTarget = getContactLink(alias);

                    return {
                        id: alias,
                        title,
                        description: alias,
                        onClick: () => navigate(navigationTarget),
                        navigationTarget
                    };
                });

            return resultList.length > MaxSearchResultCount ? resultList.slice(0, MaxSearchResultCount) : resultList;
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [navigate]
    );

    useUniversalSearch("Contacts", "contacts", searchContact, false, AppRegistry.Contacts.path);
};
